import React, { useEffect } from 'react';
import { Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { ScanIqCustomerProfileCard } from './containers/ScanIqCustomerProfileCard/ScanIqCustomerProfileCard';
import { scanIqCustomerProfileStore } from '../../stores/scanIqCustomerProfileStore';
import { ProfileTab } from './containers/ProfileTab/ProfileTab';
import { LbTabPanel, LbTabs, TabsConfig } from '../../../shared/components/tabs';
import {
  SCAN_IQ_PROFILE_TABS,
  ScanIqProfileTab,
} from '../../constants/scanIqCustomerProfileTabs';
import { getRouteParam, setRouteParams } from '../../../shared/utils/angularUtils';
import { useRouteParam } from '../../../shared/hooks/useRouteParam';
import { InbodyIndicatorsTab } from '../../../inbody/pages/customer-profile/containers/NgzInbodyIndicatorsTab/NgzInbodyIndicatorsTab';
import { calculateFullYears } from '../../../shared/utils/dateUtils';
import { CUSTOMER_TYPE } from '../../../shared/constants/customer/customerType';
import { pathQueryParams } from '../../../shared/constants/pathQueryParams';
import { inbodyIndicatorsStore } from '../../../inbody';

const NgzScanIqCustomerProfile = observer(() => {
  const { customerProfileInfo, getCustomerProfileInfo, setDefaultValues } =
    scanIqCustomerProfileStore;

  const entityId = getRouteParam('entityId');
  const customerId = getRouteParam('customerId');
  const currentTab = useRouteParam(pathQueryParams.currentTab, {
    defaultValue: SCAN_IQ_PROFILE_TABS.IN_BODY_INDICATORS,
  });

  useEffect(() => {
    getCustomerProfileInfo(entityId, customerId);

    return () => {
      setDefaultValues();
      inbodyIndicatorsStore.setDefaultValues();
    };
  }, []);

  if (!customerProfileInfo) {
    return null;
  }

  const { personalData } = customerProfileInfo;

  const tabsConfig: TabsConfig<ScanIqProfileTab>[] = [
    {
      label: 'Profile',
      value: SCAN_IQ_PROFILE_TABS.PROFILE,
      panel: <ProfileTab entityId={entityId} customerId={customerId} />,
    },
    {
      label: 'Body Composition Metrics',
      value: SCAN_IQ_PROFILE_TABS.IN_BODY_INDICATORS,
      panel: (
        <InbodyIndicatorsTab
          customerId={customerId}
          firstName={personalData.firstName}
          lastName={personalData.lastName}
          age={calculateFullYears(personalData.dateOfBirth)}
          gender={personalData.gender}
          height={personalData.height}
          inbodyId={customerProfileInfo.inbodyId}
          customerType={CUSTOMER_TYPE.SCAN_IQ}
          entityId={entityId}
        />
      ),
    },
  ];

  return (
    <Container>
      <LbTabs
        value={currentTab}
        onValueChange={(value) => {
          setRouteParams({ [pathQueryParams.currentTab]: value });
        }}
      >
        <ScanIqCustomerProfileCard tabsConfig={tabsConfig} />
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
    </Container>
  );
});

angularizeWithProviders(NgzScanIqCustomerProfile, 'ngzScanIqCustomerProfile', {});

export { NgzScanIqCustomerProfile };
